/**
 * Formats a date string or Date object to a localized date string
 * @param date - Date string or Date object to format
 * @param locale - Optional locale string (e.g., 'en-US', 'ar-SA')
 * @returns Formatted date string
 */
export const formatDate = (date: string | Date, locale?: string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString(locale);
};

/**
 * Formats a date string or Date object to a localized date and time string
 * @param date - Date string or Date object to format
 * @param locale - Optional locale string (e.g., 'en-US', 'ar-SA')
 * @returns Formatted date and time string
 */
export const formatDateTime = (
  date: string | Date,
  locale?: string
): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleString(locale);
};
